/* global axios */
import ApiClient from '../ApiClient';

class BotTestChatAPI extends ApiClient {
  constructor() {
    super('omni/agent_bots', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/test_chat/conversation
  getConversation(botId) {
    const url = `${this.url}/${botId}/test_chat/conversation`;
    //console.log('[BotTestChat] getConversation URL:', url);
    return axios.get(url);
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/test_chat/messages
  getMessages(botId, params = {}) {
    const url = `${this.url}/${botId}/test_chat/messages`;
    //console.log('[BotTestChat] getMessages URL:', url, 'params:', params);
    return axios.get(url, { params });
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/test_chat/send_message
  sendMessage(botId, content) {
    const url = `${this.url}/${botId}/test_chat/send_message`;
    //console.log('[BotTestChat] sendMessage URL:', url, 'content:', content);
    return axios.post(url, { content });
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/test_chat/reset
  reset(botId, clearHistory = false) {
    const url = `${this.url}/${botId}/test_chat/reset`;
    //console.log('[BotTestChat] reset URL:', url, 'clearHistory:', clearHistory);
    return axios.post(url, {
      clear_history: clearHistory,
    });
  }
}

export default new BotTestChatAPI();

